var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPstake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.72 10.715h-2.717c0-.395-.227-1.286-1.14-1.286s-1.157.698-1.149 1.028c0 .857 1.402 1.432 2.083 1.616c2.644.78 3.129 2.34 3.043 3.021c.137 1.256-.429 3.763-3.772 3.763s-4.011-2.254-3.925-3.428h2.571c0 .398.244 1.286 1.354 1.286c.888 0 1.2-.986 1.218-1.33c.068-.33-.386-.942-2.533-1.555c-2.692-.767-2.602-2.657-2.602-3.167c0-.514.013-3.377 3.785-3.377c3.017 0 3.78 2.301 3.784 3.428"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E50913",
    d: "M8.143 5.143h7.714v1.714H8.143z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPstake);
export default __webpack_public_path__ + "static/media/pstake.120978f79d794f4b983424a0f4a4e636.svg";
export { ForwardRef as ReactComponent };